import { authState } from '../config/ids';

export const clearAuthState = (): void => localStorage.removeItem(authState);
